import React, { forwardRef } from "react";
import { DateTime } from "luxon";

type ZonedInputProps = {
    value?: string;
    placeholder: string;
    onClick?: () => void;
    disabled?: boolean;
    timeZone: string;
    selectedDate: Date | null;
    className: string;
};

const ZonedInput = forwardRef<HTMLInputElement, ZonedInputProps>(
    ({ value, placeholder, onClick, disabled, timeZone, selectedDate, className }, ref) => {
        const formattedValue = selectedDate
            ? DateTime.fromJSDate(selectedDate, { zone: timeZone }).toFormat("dd.MM.yyyy HH:mm")
            : value || "";

        return (
            <input
                ref={ref}
                readOnly
                onClick={onClick}
                disabled={disabled}
                value={formattedValue}
                placeholder={placeholder}
                className={className}
            />
        );
    }
);

ZonedInput.displayName = "ZonedInput";

export default React.memo(ZonedInput);
